// Include jQuery plugins
require('slick-carousel/slick/slick.min.js');
require('tooltipster/dist/js/tooltipster.bundle.min.js');
require('@fancyapps/fancybox/dist/jquery.fancybox.min.js');
require('jquery-match-height/dist/jquery.matchHeight-min.js');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global handorgel, alandia, google */

(function($) {
  const wntrTheme = {
    body: $('body'),
    html: $('html'),
    document: $(document),
    header: $('header'),
    current_position: 0,
    video_banner_height: 0,
    gmap_initalized: false,
    event_registration_forms: {},
    current_event_registration_id: 0,
    event_with_ics_files: [],
    active_search_string: '',
    gmap_correspondent_markers: [],
    active_correspondents: [],
    is_mobile_device: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),

    /**
     * Initialise theme JS on page load
     */
    init: function() {
      // Do we have JS?
      $('html').removeClass('no-js');

      // Automatically call all methods that start with __, in the order they're defined
      for(const prop in wntrTheme) {
        if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
          wntrTheme[prop].call();
        }
      }
    },

    /**
     * Toggle read more content
     */
    __toggleReadMoreContent: function() {
      wntrTheme.body.find('.read-more__content-toggle').on('click', function() {
        $(this).closest('.read-more__content-divider').toggleClass('read-more__content-divider--active');
        $(this).remove();
      });
    },

    __stickyHeadingPart: function() {
      if($(window).width() >= 1024) {
        const header = wntrTheme.body.find('#main-header');

        let scrollTimeout = null;
        let lastScroll = 0;
        const throttle = 50;

        $(document).ready(function() {
          if($(window).scrollTop() <= lastScroll) {
            header.removeClass('sticky-header');
          } else {
            header.addClass('sticky-header');
          }

          if($(window).scrollTop() >= 140) {
            wntrTheme.body.addClass('breadcrumb-z-index');
          } else {
            wntrTheme.body.removeClass('breadcrumb-z-index');
          }
        });

        $(window).on('scroll', function() {
          if(!scrollTimeout) {
            scrollTimeout = setTimeout(function() {
              if($(window).scrollTop() <= lastScroll) {
                header.removeClass('sticky-header');
              } else if($(window).scrollTop() >= lastScroll) {
                header.addClass('sticky-header');
              }

              if($(window).scrollTop() >= 140) {
                wntrTheme.body.addClass('breadcrumb-z-index');
              } else {
                wntrTheme.body.removeClass('breadcrumb-z-index');
              }

              scrollTimeout = null;
              lastScroll = $(window).scrollTop();
            }, throttle);
          }
        });
      }
    },

    /**
     * Fix tabs overflowing breadcrumbs
     */
    __addClassToImageBannerIfFollowedByContentTabs: function() {
      const imageBanner = wntrTheme.body.find('.page-section-image-banner');
      const contentTabs = wntrTheme.body.find('.page-section-content-tabs');
      if(imageBanner.next(contentTabs)) {
        imageBanner.addClass('followed-by-content-tabs');
      }
    },

    /**
     * Download loss prevention safety observations
     */
    __downloadLossPreventionDocs: function() {
      const $loss_prevention_form = wntrTheme.body.find('#loss-prevention__form');
      const $loss_prevention_form_messages = wntrTheme.body.find('.loss-prevention__form-messages');

      wntrTheme.body.on(
        'click',
        '#loss-prevention__action--safety-observations, #loss-prevention__action--safety-tips',
        function(e) {
          e.preventDefault();
          const $el = $(this);

          const data = {
            action: 'loss_prevention__safety_observations',
            username: $loss_prevention_form.find('input[name=username]').val(),
            password: $loss_prevention_form.find('input[name=password]').val(),
            'doc-type': $el.data('doc-type'),
          };

          $.ajax({
            url: alandia.ajax_url,
            data: data,
            type: 'POST',
            beforeSend: function() {
              $el.addClass('loading');
              $loss_prevention_form_messages.empty();
            },
            success: function(data) {
              const result = jQuery.parseJSON(data);

              // If error, show reason, else download csv file
              if(result['type'] === 'error') {
                $loss_prevention_form_messages.html(
                  '<p class="loss-prevention__form-message loss-prevention__form-message--' +
                  result['type'] +
                  '">' +
                  result['text'] +
                  '</p>'
                );
              } else if(result['type'] === 'success') {
                const blob = new Blob([result['text']], { type: 'text/csv;charset=utf-8' });
                // Download url
                const url = window.URL || window.webkitURL;
                const link = url.createObjectURL(blob);
                const a = $('<a />');
                a.attr('download', 'safety-' + $el.data('doc-type') + '.csv');
                a.attr('href', link);
                $('body').append(a);
                a[0].click();
                $('body').remove(a);
              }
            },
            complete: function() {
              $el.removeClass('loading');
            },
          });
        }
      );
    },

    /**
     * Handle correspondent map
     */
    __handleCorrespondentsMap: () => {
      const $map_container = wntrTheme.body.find('#correspondent-map__gmap');
      if($map_container.length > 0) {
        $.fancybox.defaults.touch = false;
        wntrTheme.body.find('.correspondent-map__tabs-btn--map').on('click', function() {
          if(wntrTheme.body.find('.correspondent-map').hasClass('correspondent-map--gmap-initialized')) {
            return;
          }

          wntrTheme.renderCorrespondentMap($map_container);
        });
      }
    },

    /**
     * Render the correspondent map
     */
    renderCorrespondentMap: ($map_container) => {
      const locations = $map_container.data('markers');
      const map = new google.maps.Map($map_container[0], {
        zoom: 2,
        center: new google.maps.LatLng(29.401320112901555, 14.567872067020279),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        gestureHandling: 'cooperative',
      });

      /*for(let j = 0; j < wntrTheme.gmap_correspondent_markers.length; j++) {
                wntrTheme.gmap_correspondent_markers[j].setMap(null);
            }
            wntrTheme.gmap_correspondent_markers = [];*/

      const infowindow = new google.maps.InfoWindow();

      const iconMarker = {
        url: $map_container.data('marker-url'),
        size: new google.maps.Size(36, 36),
        scaledSize: new google.maps.Size(36, 36),
      };

      let marker;
      let i;

      for(i = 0; i < locations.length; i++) {
        if(
          wntrTheme.active_correspondents.length > 0 &&
          !wntrTheme.active_correspondents.includes(locations[i]['name'].toLowerCase())
        ) {
          //continue;
        }

        marker = new google.maps.Marker({
          position: new google.maps.LatLng(locations[i]['lat'], locations[i]['lng']),
          map: map,
          animation: null,
        });

        marker.setIcon(iconMarker);

        google.maps.event.addListener(
          marker,
          'click',
          (function(marker, i) {
            return function() {
              infowindow.setContent(
                '<div class="correspondent__info-window">' +
                '<h2 class="correspondent__info-window-title">' +
                locations[i]['name'] +
                '</h2>' +
                (locations[i]['country'].length > 0
                  ? '<div class="correspondent__info-window-country"><span>' +
                  $map_container.data('country-translation') +
                  ':</span>' +
                  locations[i]['country'] +
                  '</div>'
                  : '') +
                (locations[i]['port'].length > 0
                  ? '<div class="correspondent__info-window-country"><span>' +
                  $map_container.data('port-translation') +
                  ':</span>' +
                  locations[i]['port'] +
                  '</div>'
                  : '') +
                (locations[i]['type-of-service'].length > 0
                  ? '<div class="correspondent__info-window-type-of-service"><span>' +
                  $map_container.data('type-of-service-translation') +
                  ':</span>' +
                  locations[i]['type-of-service'] +
                  '</div>'
                  : '') +
                '<hr>' +
                (locations[i]['email'].length > 0
                  ? '<div class="correspondent__info-window-email"><span>' +
                  $map_container.data('email-translation') +
                  ':</span>' +
                  '<a href="mailto:' +
                  locations[i]['email'] +
                  '">' +
                  locations[i]['email'] +
                  '</a>' +
                  '</div>'
                  : '') +
                (locations[i]['phone'].length > 0
                  ? '<div class="correspondent__info-window-phone"><span>' +
                  $map_container.data('phone-translation') +
                  ':</span>' +
                  '<a href="tel:' +
                  locations[i]['phone'] +
                  '">' +
                  locations[i]['phone'] +
                  '</a>' +
                  '</div>'
                  : '') +
                '<div class="correspondent__info-window-route">' +
                '<button class="btn--clean" data-fancybox data-src="#' +
                locations[i]['fancybox-id'] +
                '">View more</button>' +
                '</div>' +
                '</div>'
              );
              infowindow.open(map, marker);
            };
          })(marker, i)
        );

        //wntrTheme.gmap_correspondent_markers.push(marker);
      }

      /*const store_location_search = document.getElementById('correspondent-map__search-form-map-search');

            const autocomplete = initAutocomplete(store_location_search);

            google.maps.event.addListener(autocomplete, 'place_changed', function() {
                const place = autocomplete.getPlace();

                if(place.geometry != undefined) {
                    map.setCenter(place.geometry.location);
                    map.fitBounds(place.geometry.viewport);
                }
            });

            wntrTheme.body.find('.correspondent-map').addClass('correspondent-map--gmap-initialized');

            function initAutocomplete(input) {
                const options = {};
                return new google.maps.places.Autocomplete(input, options);
            }

            wntrTheme.body.find('.correspondent-map__search-form--map').on('submit', function(e) {
                e.preventDefault();
                return false;
            });*/
    },

    /**
     * Toggle correspondent tabs
     */
    __toggleCorrespondentsTabs: () => {
      const $tab_btns = wntrTheme.body.find('.correspondent-map__tabs-btn');
      const $tabs = wntrTheme.body.find('.correspondent-map__tab');
      //const $search_tabs = wntrTheme.body.find('.correspondent-map__search');
      $tab_btns.on('click', function() {
        const $tab_btn = $(this);

        $tab_btns.removeClass('active');
        $tab_btn.addClass('active');

        $tabs.removeClass('active');
        wntrTheme.body.find('.correspondent-map__tab[data-tab=' + $tab_btn.data('tab') + ']').addClass('active');
        //$search_tabs.removeClass('active');
        //wntrTheme.body.find('.correspondent-map__search[data-tab=' + $tab_btn.data('tab') + ']').addClass('active');
      });
    },

    /**
     * Filter classes by text search
     */
    __filterCorrespondentsByTextSearch: () => {
      wntrTheme.body.find('.correspondent-map__search-form--list').on('submit', function(e) {
        e.preventDefault();
        const search_text = $(this).find('input[type=search]').val().toLowerCase();
        const search_text_formatted = search_text
          .replace(/&/g, '&amp;')
          .replace(/>/g, '&gt;')
          .replace(/</g, '&lt;')
          .replace(/"/g, '&quot;');
        wntrTheme.active_search_string = encodeURIComponent(search_text_formatted);

        handleTextSearchFilters(search_text_formatted);
        addToHistoryState();
      });

      wntrTheme.body.find('#correspondent-map__search-form-list-search').on('keyup', function(e) {
        if($(this).val().length > 0) {
          wntrTheme.body.find('.btn--clear-search').addClass('active');
        } else {
          wntrTheme.body.find('.btn--clear-search').removeClass('active');
        }

        const code = e.charCode || e.keyCode;
        if(code === 27) {
          wntrTheme.body.find('#correspondent-map__search-form-list-search').val('');
          wntrTheme.body.find('.btn--clear-search').removeClass('active');
          wntrTheme.body.find('.correspondent-map__container').removeClass('correspondent-map__container--active');
          wntrTheme.body.find('.correspondent-map__results').removeClass('correspondent-map__results--active');

          handleTextSearchFilters('');
          addToHistoryState();
        }
      });

      wntrTheme.body.find('.btn--clear-search').on('click', function() {
        wntrTheme.body.find('#correspondent-map__search-form-list-search').val('');
        wntrTheme.body.find('.btn--clear-search').removeClass('active');
        wntrTheme.body.find('.correspondent-map__container').removeClass('correspondent-map__container--active');
        wntrTheme.body.find('.correspondent-map__results').removeClass('correspondent-map__results--active');

        handleTextSearchFilters('');
        addToHistoryState();
      });

      // Handle search filters
      function handleTextSearchFilters(search_text) {
        if(search_text.length > 0) {
          wntrTheme.body.find('.correspondent-map').addClass('loading');
          let num_of_results = 0;

          const correspondents = wntrTheme.body.find('.correspondent');
          wntrTheme.active_correspondents = [];
          correspondents.removeClass('active');
          wntrTheme.body.find('.correspondent-map__container').removeClass('correspondent-map__container--active');
          wntrTheme.body.find('.correspondent-map__results').removeClass('correspondent-map__results--active');

          $.each(correspondents, function() {
            const correspondent = $(this);

            // Check if name exists
            const name = correspondent.find('.correspondent__name').html().toLowerCase();
            if(name.indexOf(search_text) !== -1) {
              num_of_results++;
              correspondent.addClass('active');
              wntrTheme.body.find('.correspondent-map__container').addClass('correspondent-map__container--active');
              wntrTheme.active_correspondents.push(name);
            }

            // Check if country exists
            const country = correspondent.find('.correspondent__country').html().toLowerCase();
            if(country.indexOf(search_text) !== -1) {
              num_of_results++;
              correspondent.addClass('active');
              wntrTheme.body.find('.correspondent-map__container').addClass('correspondent-map__container--active');
              wntrTheme.active_correspondents.push(name);
            }
          });

          if(num_of_results === 0) {
            wntrTheme.body.find('.correspondent-map__results').addClass('correspondent-map__results--active');
          }

          wntrTheme.active_correspondents = wntrTheme.active_correspondents.filter(function(item, pos) {
            return wntrTheme.active_correspondents.indexOf(item) === pos;
          });

          wntrTheme.renderCorrespondentMap(wntrTheme.body.find('#correspondent-map__gmap'));

          wntrTheme.body.find('.correspondent-map').removeClass('loading');
        }
      }

      function addToHistoryState() {
        let url = location.protocol + '//' + location.host + location.pathname;

        if(wntrTheme.active_search_string.length > 0) {
          url = url + '?search_query=' + wntrTheme.active_search_string;
        }

        window.history.pushState({}, '', url);
      }

      window.onpopstate = function(event) {
        if(event.state) {
          const url = new URL(window.location.href);
          const search_query = url.searchParams.get('search_query');

          if(search_query.length > 0) {
            const search_text = search_query.toLowerCase();
            const search_text_formatted = search_text
              .replace(/&/g, '&amp;')
              .replace(/>/g, '&gt;')
              .replace(/</g, '&lt;')
              .replace(/"/g, '&quot;');
            wntrTheme.active_search_string = encodeURIComponent(search_text_formatted);
            wntrTheme.body.find('.correspondent-map__search-form--list input[type=search]').val(search_text_formatted);

            handleTextSearchFilters(search_text_formatted);
            addToHistoryState();
          }
        }
      };
    },

    /**
     * Handle IE users
     */
    __handleIEUsers: function() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');

      // IE browser
      // eslint-disable-next-line no-useless-escape
      if(msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        wntrTheme.body.find('.urget-news-banner--ie').addClass('visible');
      }
    },

    /**
     * Handle correspondent tabs
     */
    __handleCorrespondentTabs: function() {
      const $tab = wntrTheme.body.find('.correspondent-preview__tab');
      const $tab_content = wntrTheme.body.find('.correspondent-preview__tab-content');
      const $search_wrappers = wntrTheme.body.find('.correspondent-preview__search-wrapper');

      $tab.on('click', function() {
        const $el = $(this);

        $tab.removeClass('correspondent-preview__tab--active');
        $tab_content.removeClass('correspondent-preview__tab-content--active');
        $search_wrappers.removeClass('correspondent-preview__search-wrapper--active');

        $el.addClass('correspondent-preview__tab--active');
        wntrTheme.body
          .find('.correspondent-preview__' + $el.data('tab'))
          .addClass('correspondent-preview__tab-content--active');
        wntrTheme.body
          .find('.correspondent-preview__' + $el.data('tab') + '-search-wrapper')
          .addClass('correspondent-preview__search-wrapper--active');

        if($el.data('tab') === 'map' && !wntrTheme.gmap_initalized) {
          wntrTheme.initGoogleMaps();
        }
      });
    },

    /**
     * Download all eps files
     */
    __downloadAllEPSFiles: function() {
      const links = wntrTheme.body.find('a');

      $.each(links, function() {
        const el = $(this);
        const href = el.attr('href');
        if(href && href.length > 0 && href.includes('.eps')) {
          el.attr('download', 'download');
        }
      });
    },

    /**
     * Init Google Maps
     */
    initGoogleMaps: function() {
      const map_wrapper = wntrTheme.body.find('#correspondent-preview__map-gmap');

      if(map_wrapper.length > 0) {
        $.each(map_wrapper, function() {
          const el = $(this);
          const locations = el.data('markers');

          const map = new google.maps.Map(el[0], {
            zoom: 2,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            gestureHandling: 'cooperative',
            styles: [
              {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#e9e9e9',
                  },
                  {
                    lightness: 17,
                  },
                ],
              },
              {
                featureType: 'landscape',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#f5f5f5',
                  },
                  {
                    lightness: 20,
                  },
                ],
              },
              {
                featureType: 'road.highway',
                elementType: 'geometry.fill',
                stylers: [
                  {
                    color: '#ffffff',
                  },
                  {
                    lightness: 17,
                  },
                ],
              },
              {
                featureType: 'road.highway',
                elementType: 'geometry.stroke',
                stylers: [
                  {
                    color: '#ffffff',
                  },
                  {
                    lightness: 29,
                  },
                  {
                    weight: 0.2,
                  },
                ],
              },
              {
                featureType: 'road.arterial',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#ffffff',
                  },
                  {
                    lightness: 18,
                  },
                ],
              },
              {
                featureType: 'road.local',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#ffffff',
                  },
                  {
                    lightness: 16,
                  },
                ],
              },
              {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#f5f5f5',
                  },
                  {
                    lightness: 21,
                  },
                ],
              },
              {
                featureType: 'poi.park',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#dedede',
                  },
                  {
                    lightness: 21,
                  },
                ],
              },
              {
                elementType: 'labels.text.stroke',
                stylers: [
                  {
                    visibility: 'on',
                  },
                  {
                    color: '#ffffff',
                  },
                  {
                    lightness: 16,
                  },
                ],
              },
              {
                elementType: 'labels.text.fill',
                stylers: [
                  {
                    saturation: 36,
                  },
                  {
                    color: '#333333',
                  },
                  {
                    lightness: 40,
                  },
                ],
              },
              {
                elementType: 'labels.icon',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'transit',
                elementType: 'geometry',
                stylers: [
                  {
                    color: '#f2f2f2',
                  },
                  {
                    lightness: 19,
                  },
                ],
              },
              {
                featureType: 'administrative',
                elementType: 'geometry.fill',
                stylers: [
                  {
                    color: '#fefefe',
                  },
                  {
                    lightness: 20,
                  },
                ],
              },
              {
                featureType: 'administrative',
                elementType: 'geometry.stroke',
                stylers: [
                  {
                    color: '#fefefe',
                  },
                  {
                    lightness: 17,
                  },
                  {
                    weight: 1.2,
                  },
                ],
              },
            ],
          });

          const infowindow = new google.maps.InfoWindow();
          const markers = [];

          const iconMarker = {
            url: el.data('marker-url'),
            size: new google.maps.Size(36, 36),
            scaledSize: new google.maps.Size(36, 36),
          };

          let marker;
          let i;
          for(i = 0; i < locations.length; i++) {
            marker = new google.maps.Marker({
              position: new google.maps.LatLng(locations[i]['lat'], locations[i]['lng']),
              map: map,
              animation: google.maps.Animation.DROP,
            });

            marker.setIcon(iconMarker);

            google.maps.event.addListener(
              marker,
              'click',
              (function(marker, i) {
                return function() {
                  infowindow.setContent(
                    '<div class="correspondent__info">' +
                    '<h2 class="correspondent__info-title">' +
                    locations[i]['title'] +
                    '</h2>' +
                    '</div>'
                  );
                  infowindow.open(map, marker);
                };
              })(marker, i)
            );

            markers.push(marker);
          }

          const store_location_search = document.getElementById('correspondent-preview__map-search');

          const autocomplete = initAutocomplete(store_location_search);

          google.maps.event.addListener(autocomplete, 'place_changed', function() {
            const place = autocomplete.getPlace();

            map.setCenter(place.geometry.location);
            map.setZoom(14);
          });
        });
      }

      function initAutocomplete(input) {
        const options = {
          types: ['(cities)'],
          componentRestrictions: { country: 'SE' },
        };
        return new google.maps.places.Autocomplete(input, options);
      }
    },

    /**
     * Set language cookie
     */
    __setLanguageCookie: function() {
      if(alandia.current_blog_id === '5') {
        const pref_lang = getCookie('wntr_pref_lang');

        // If pref lang is swedish and we're requesting the finnish site, redirect to swe startpage
        if(pref_lang === 'sv' && $('html').attr('lang') === 'fi' && wntrTheme.body.hasClass('home')) {
          //window.location.href = alandia.sv_start_page;
        }

        wntrTheme.body.find('.header__nav-bar-languages a').on('click', function(e) {
          e.preventDefault();
          const $el = $(this);
          const lang = $el.data('lang');

          setCookie('wntr_pref_lang', lang, 365);

          window.location.href = $el.attr('href');
        });
      }

      function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = 'expires=' + d.toGMTString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
      }

      function getCookie(cname) {
        const name = cname + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while(c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if(c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }

        return '';
      }
    },

    /**
     * Generate ICS file
     */
    __generateICSFile: () => {
      let icsFile = null;

      wntrTheme.body.on('click', '.event__add-to-cal', function() {
        const event_id = $(this).data('event-id');
        const dtstart = $(this).data('dtstart');
        const dtend = $(this).data('dtend');
        const location = $(this).data('location');
        const description = $(this).data('description');
        const url = $(this).data('url');
        const timezone = $(this).data('timezone');
        const timestamp = $(this).data('timestamp');

        $(this).attr({
          href: makeIcsFile(dtstart, dtend, description, location, url, timezone, timestamp, event_id),
          download: 'calendar-invite-alandia.ics',
        });
      });

      function makeIcsFile(dateStart, dateEnd, summary, location, url, timezone, timestamp, event_id) {
        const cal_markup =
          'BEGIN:VCALENDAR\n' +
          'CALSCALE:GREGORIAN\n' +
          'METHOD:PUBLISH\n' +
          'PRODID:-//Alandia Event Calendar//EN\n' +
          'VERSION:2.0\n' +
          'BEGIN:VEVENT\n' +
          'UID:alandia\n' +
          'DTSTAMP:' +
          timestamp +
          '\n' +
          'DTSTART;TZID=' +
          timezone +
          ':' +
          dateStart +
          '\n' +
          'DTEND;TZID=' +
          timezone +
          ':' +
          dateEnd +
          '\n' +
          'LOCATION:' +
          location +
          '\n' +
          'SUMMARY:' +
          summary +
          '\n' +
          'URL:' +
          url +
          '\n' +
          'DESCRIPTION:' +
          url +
          '\n' +
          'END:VEVENT\n' +
          'END:VCALENDAR';

        const data = new File([cal_markup], { type: 'text/plain' });

        // If we are replacing a previously generated file we need to
        // manually revoke the object URL to avoid memory leaks.
        if(wntrTheme.event_with_ics_files.includes(event_id)) {
          window.URL.revokeObjectURL(icsFile);
        }

        icsFile = window.URL.createObjectURL(data);

        if(wntrTheme.event_with_ics_files.indexOf(event_id) === -1) {
          wntrTheme.event_with_ics_files.push(event_id);
        }

        return icsFile;
      }
    },

    /**
     * Reload event form before opening it
     */
    __reloadEventForm: () => {
      const $event_registration_buttons = wntrTheme.body.find('.event__register-button');

      if($event_registration_buttons.length > 0) {
        $.each($event_registration_buttons, function() {
          const $button = $(this);
          const form_id = $button.data('form-id');

          if(wntrTheme.body.find('.events__inner #registration_form_' + form_id).length > 0) {
            wntrTheme.event_registration_forms[form_id] = wntrTheme.body
              .find('.events__inner #registration_form_' + form_id)
              .find('.gform_wrapper')[0].outerHTML;
          }
        });

        wntrTheme.body.find('.event__register-button').on('click', function() {
          const $el = $(this);
          const form_id = $el.data('form-id');
          const $modal = wntrTheme.body.find($el.data('src'));
          const $modal_heading = $modal.find('.event__register-heading');
          const $confirmation = $modal.find('.gform_confirmation_wrapper');
          const $eventTitleField = wntrTheme.body.find('#registration_form_' + $el.data('form-id'));
          wntrTheme.current_event_registration_id = $el.data('event-id');

          if($confirmation.length > 0) {
            $confirmation.remove();
            $modal_heading.after(wntrTheme.event_registration_forms[form_id]);
          }

          if($eventTitleField.find('.gf_event-title input').length > 0) {
            $eventTitleField.find('.gf_event-title input').val($el.data('event-title'));

            setTimeout(function() {
              $eventTitleField.find('.gf_event-title input').blur();
              $eventTitleField.find('.gf_event-title input').closest('li').next().find('input')[0].focus();
              $eventTitleField.find('.gf_event-title input').attr('tabindex', '-1');
              $eventTitleField.find('.gf_event-title input').prop('tabindex', '-1');

              $eventTitleField.data('event-id', $el.data('event-id'));
            });
          }
        });
      }

      wntrTheme.body.find('.single-event__register-button').on('click', function() {
        const $el = $(this);
        const $eventTitleField = wntrTheme.body.find('#registration_form_' + $el.data('form-id'));
        wntrTheme.current_event_registration_id = $el.data('event-id');

        if($eventTitleField.find('.gf_event-title input').length > 0) {
          $eventTitleField.find('.gf_event-title input').val($el.data('event-title'));

          setTimeout(function() {
            $eventTitleField.find('.gf_event-title input').blur();
            $eventTitleField.find('.gf_event-title input').closest('li').next().find('input')[0].focus();
            $eventTitleField.find('.gf_event-title input').attr('tabindex', '-1');
            $eventTitleField.find('.gf_event-title input').prop('tabindex', '-1');

            $eventTitleField.data('event-id', $el.data('event-id'));
          });
        }
      });
    },

    /**
     * After event form submitted
     */
    __afterEventFormSubmitted: () => {
      $(document).on('gform_confirmation_loaded', function() {
        const action_button_clone = wntrTheme.body
          .find('.event__content--' + wntrTheme.current_event_registration_id + ' .event__action-buttons')
          .clone();

        if(
          wntrTheme.body.find('.fancybox-container.fancybox-is-open .gform_confirmation_wrapper .event__action-buttons')
            .length <= 0
        ) {
          action_button_clone.css('display', 'flex');
          wntrTheme.body
            .find('.fancybox-container.fancybox-is-open .gform_confirmation_wrapper')
            .append(action_button_clone);
        }
      });
    },

    /**
     * Track insurance options
     */
    __trackInsuranceOptions: () => {
      wntrTheme.body.find('.insurance-options a').on('click', function(e) {
        const $el = $(this);
        const href = $el.attr('href');

        if(href.indexOf('shop.alandia') !== -1) {
          const caps_code = getParameterByName('CODE', href);
          const caps_code_2 = getParameterByName('CODE2', href);
          const code = getParameterByName('code', href);
          const code_2 = getParameterByName('code2', href);

          let insurance_option = null;
          if(caps_code) {
            const caps_code_to_lower = caps_code.toLowerCase();
            insurance_option = caps_code_to_lower;
          } else if(code) {
            const code_to_lower = code.toLowerCase();
            insurance_option = code_to_lower.toLowerCase();
          }

          if(caps_code_2) {
            const caps_code_2_to_lower = caps_code_2.toLowerCase();
            insurance_option = caps_code_2_to_lower;
          } else if(code_2) {
            const code_2_to_lower = code_2.toLowerCase();
            insurance_option = code_2_to_lower.toLowerCase();
          }

          if(insurance_option) {
            e.preventDefault();

            let alandia_products = [];

            if(insurance_option === 'vs') {
              alandia_products = [
                {
                  id: 'VS',
                  name: 'Jetski',
                },
              ];
            } else if(insurance_option === 'sb') {
              alandia_products = [
                {
                  id: 'SB',
                  name: 'Sailboat',
                },
              ];
            } else if(insurance_option === 'ub') {
              alandia_products = [
                {
                  id: 'MB_UB',
                  name: 'Outboard motorboat',
                },
              ];
            } else if(insurance_option === 'ib') {
              alandia_products = [
                {
                  id: 'MB_IB',
                  name: 'Inboard motorboat',
                },
              ];
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'eec.add',
              ecommerce: {
                add: {
                  products: alandia_products,
                },
              },
              eventCallback: function() {
                window.location = $el.attr('href');
              },
              eventTimeout: 2000,
            });
          }
        }

        function getParameterByName(name, url = window.location.href) {
          // eslint-disable-next-line no-useless-escape
          name = name.replace(/[\[\]]/g, '\\$&');
          const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
          if(!results) return null;
          if(!results[2]) return '';
          return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
      });
    },

    /**
     * Load more articles
     */
    __loadMoreArticles: () => {
      wntrTheme.body.find('.article-preview__load-more-btn').on('click', function() {
        const $el = $(this);
        $el.closest('.article-preview__container').toggleClass('article-preview__container--paginate');

        if($el.closest('.article-preview__container').hasClass('article-preview__container--paginate')) {
          $el.text($el.data('more'));
        } else {
          $el.text($el.data('less'));
        }
      });
    },

    /**
     * Show embed video in video banner
     */
    __videoBannerPlay: () => {
      wntrTheme.body.find('.video-banner__play').on('click', function() {
        wntrTheme.video_banner_height = wntrTheme.body.find('.video-banner__inner').outerHeight();

        const $el = $(this);
        const $iframe = $el.closest('.video-banner').find('iframe');
        $el.closest('.video-banner').addClass('video-banner--embed-active');

        const embed_height = wntrTheme.body.find('.video-banner__embed').outerHeight();
        wntrTheme.body.find('.video-banner__inner').css('min-height', embed_height + 'px');

        setTimeout(function() {
          const symbol = $iframe[0].src.indexOf('?') > -1 ? '&' : '?';
          $iframe[0].src += symbol + 'autoplay=1';
        }, 500);
      });

      wntrTheme.body.find('.video-banner__close').on('click', function() {
        closePlayer($(this));
      });

      $(document).keyup(function(e) {
        if(e.keyCode === 27 && wntrTheme.body.find('.video-banner').hasClass('video-banner--embed-active')) {
          closePlayer(wntrTheme.body.find('.video-banner__close'));
        }
      });

      function closePlayer(element) {
        const $el = element;
        const $iframe = $el.closest('.video-banner').find('iframe');

        $el.closest('.video-banner').removeClass('video-banner--embed-active');

        wntrTheme.body.find('.video-banner__inner').css('min-height', wntrTheme.video_banner_height + 'px');

        setTimeout(function() {
          const iframe_src = $iframe.attr('src');
          const iframe_src_no_autoplay = iframe_src.replace('&autoplay=1', '').replace('?autoplay=1', '');
          $iframe[0].src = iframe_src_no_autoplay;
        }, 500);
      }
    },

    /**
     * Add Scroll to GF list items
     */
    __gfListItemsScroll: () => {
      if(wntrTheme.body.find('.ginput_list').length > 0) {
        wntrTheme.body.find('.ginput_list').closest('li.gfield').addClass('gfield-sidescroll');
      }
    },

    /**
     * Toogle Insurance Options
     */
    __toggleInsuranceOptions: () => {
      let is_open = false;

      // Toggle options
      wntrTheme.body.find('.insurance-options button, .combo-button button').on('click', function() {
        $(this)
          .closest('.insurance-options, .combo-button')
          .find('ul')
          .slideDown('fast', function() {
            is_open = true;
          });
        $(this).closest('.insurance-options, .combo-button').addClass('is-active');
      });

      wntrTheme.body.find('main').on('click', function() {
        if(is_open) {
          closeOptions();
        }
      });

      // Close options on esc click
      $(document).keyup(function(e) {
        if(e.keyCode === 27) {
          closeOptions();
        }
      });

      function closeOptions() {
        wntrTheme.body
          .find('.insurance-options, .combo-button')
          .closest('.insurance-options, .combo-button')
          .find('ul')
          .slideUp('fast', function() {
            is_open = false;
          });
        wntrTheme.body.find('.insurance-options, .combo-button').closest('.insurance-options, .combo-button').removeClass('is-active');
      }
    },

    /**
     * Toggle article preview
     */
    __toggleArticlePreview: () => {
      wntrTheme.body.find('.article-preview__category-toggle-btn').on('click', function() {
        const el = $(this);

        wntrTheme.body.find('.article-preview__category-toggle-btn').removeClass('is-active');
        el.addClass('is-active');

        wntrTheme.body.find('.article-preview__container').removeClass('is-active');
        wntrTheme.body.find('.article-preview__container[data-toggle=' + el.data('toggle') + ']').addClass('is-active');

        if(wntrTheme.body.find('.spot-grid__content-heading').length > 0) {
          wntrTheme.body.find('.spot-grid__content-heading').matchHeight();
        }

        if(wntrTheme.body.find('.spot-grid__content-text').length > 0) {
          wntrTheme.body.find('.spot-grid__content-text').matchHeight();
        }
      });
    },

    /**
     * Activate tooltipster
     */
    __activateTooltipster: () => {
      if(wntrTheme.body.find('.tooltip').length > 0) {
        wntrTheme.body.find('.tooltip').tooltipster({
          contentAsHTML: true,
          theme: 'alandia-tooltipster',
          animation: 'fade',
          delay: 0,
          maxWidth: 300,
          trigger: wntrTheme.is_mobile_device ? 'click' : 'hover',
        });
      }
    },

    /**
     * Scroll to the top of the page when back to top button is clicked
     */
    __scrollToTop: () => {
      wntrTheme.body.find('.back-to-top').on('click', function() {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
      });
    },

    /**
     * Smooth scroll to global b2c contact form
     */
    __scrollToGlobalContactForm: () => {
      wntrTheme.body.find('.scroll-to-contact-form').on('click', function() {
        // Toggle mobile menu with button click
        wntrTheme.header.removeClass('mobile-menu-active');
        wntrTheme.body.removeClass('mobile-menu--active');
        wntrTheme.body.find('.header__toggle-menu-btn').removeClass('is-active');
        wntrTheme.body.removeClass('body--fixed');

        let offset = 0;
        if($(window).width() < 720) {
          offset = 90;
        }

        if($(window).width() >= 720 && $(window).width() < 1024) {
          offset = 190 / 2;
        }

        $('html, body').animate(
          {
            scrollTop: $('#footer-contact-form').offset().top - offset,
          },
          'slow'
        );
      });
    },

    /**
     * Toggle categorized accordions
     */
    __toggleCategorizedAccordions: () => {
      wntrTheme.body.find('.categorized-accordions__category-toggle-btn').on('click', function() {
        const el = $(this);

        wntrTheme.body.find('.categorized-accordions__category-toggle-btn').removeClass('is-active');
        el.addClass('is-active');

        wntrTheme.body.find('.categorized-accordion__inner').removeClass('is-active');
        wntrTheme.body
          .find('.categorized-accordion__inner[data-toggle=' + el.data('toggle') + ']')
          .addClass('is-active');
      });
    },

    /**
     * Toggle Board member content
     */
    __toggleBoardMemberContent: () => {
      wntrTheme.body.find('.board-member__content-extra-toggle').on('click', function() {
        const el = $(this);
        el.next().slideToggle('fast');
        el.toggleClass('is-active');

        if(el.hasClass('is-active')) {
          el.text(el.data('open'));
        } else {
          el.text(el.data('closed'));
        }
      });
    },

    /**
     * Init accordions
     */
    __initAccordions: () => {
      if(wntrTheme.body.find('.employee__department').length > 0) {
        $.each(wntrTheme.body.find('.employee__department'), function() {
          new handorgel($(this)[0], { ariaEnabled: false });
        });
      }

      if(wntrTheme.body.find('.categorized-accordion').length > 0) {
        $.each(wntrTheme.body.find('.categorized-accordion'), function() {
          new handorgel($(this)[0], { ariaEnabled: false });
        });
      }

      if(wntrTheme.body.find('.faq').length > 0) {
        $.each(wntrTheme.body.find('.faq'), function() {
          new handorgel($(this)[0], { ariaEnabled: false });
        });
      }

      if(wntrTheme.body.find('.correspondent-preview__accordion').length > 0) {
        $.each(wntrTheme.body.find('.correspondent-preview__accordion'), function() {
          new handorgel($(this)[0], { ariaEnabled: false });
        });
      }
    },

    /**
     * Slick sliders
     */
    __initSlickSliders: () => {
      // Spot grid
      if(wntrTheme.body.find('.page-section-spot-grid .spot-grid__inner--carousel').length > 0) {
        if($(window).width() < 610) {
          initSpotGrid();
        }

        $(window).on('resize', function() {
          const width = $(this).width();

          if(width < 610) {
            initSpotGrid();
          } else {
            const wrapper = wntrTheme.body.find('.spot-grid__wrapper');
            wrapper.removeAttr('style');
            wrapper.removeAttr('aria-hidden');
            wrapper.removeAttr('tabindex');
            wrapper.removeAttr('role');
            wrapper.removeAttr('id');
            wrapper.removeAttr('aria-describedby');
          }
        });
      }

      function initSpotGrid() {
        wntrTheme.body
          .find('.page-section-spot-grid .spot-grid__inner--carousel')
          .not('.slick-initialized')
          .slick({
            slidesToShow: 1.2,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            arrows: false,
            touchThreshold: 20,
            lazyLoad: 'progressive',
            responsive: [
              {
                breakpoint: 9999,
                settings: 'unslick',
              },
              {
                breakpoint: 625,
                settings: {
                  slidesToShow: 1.2,
                  slidesToScroll: 1,
                  infinite: false,
                  dots: true,
                  arrows: false,
                  touchThreshold: 20,
                },
              },
            ],
          });
      }

      // Insurances
      if(wntrTheme.body.find('.insurance-preview__mobile--slick').length > 0) {
        if($(window).width() < 610) {
          initInsuranceCards();
        }

        $(window).on('resize', function() {
          const width = $(this).width();

          if(width < 610) {
            initInsuranceCards();
          } else {
            const wrapper = wntrTheme.body.find('.insurance-preview__mobile-card');
            wrapper.removeAttr('style');
            wrapper.removeAttr('aria-hidden');
            wrapper.removeAttr('tabindex');
            wrapper.removeAttr('role');
            wrapper.removeAttr('id');
            wrapper.removeAttr('aria-describedby');
          }
        });
      }

      function initInsuranceCards() {
        wntrTheme.body
          .find('.insurance-preview__mobile--slick')
          .not('.slick-initialized')
          .slick({
            slidesToShow: 1.2,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            arrows: false,
            touchThreshold: 20,
            responsive: [
              {
                breakpoint: 9999,
                settings: 'unslick',
              },
              {
                breakpoint: 625,
                settings: {
                  slidesToShow: 1.2,
                  slidesToScroll: 1,
                  infinite: false,
                  dots: true,
                  arrows: false,
                  touchThreshold: 20,
                },
              },
            ],
          });
      }

      // Mentorship bullets
      if(wntrTheme.body.find('.mentorship__bullets').length > 0) {
        initMentorshipBullets();
      }

      function initMentorshipBullets() {
        wntrTheme.body
          .find('.mentorship__bullets')
          .not('.slick-initialized')
          .slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: true,
            touchThreshold: 20,
            responsive: [
              {
                breakpoint: 825,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  infinite: false,
                  dots: true,
                  arrows: false,
                  touchThreshold: 20,
                },
              },
              {
                breakpoint: 625,
                settings: {
                  slidesToShow: 1.4,
                  slidesToScroll: 1,
                  infinite: false,
                  dots: true,
                  arrows: false,
                  touchThreshold: 20,
                },
              },
            ],
          });
      }

      // Social proof
      if(wntrTheme.body.find('.social-proofs__cards').length > 0) {
        wntrTheme.body.find('.social-proofs__cards').not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false,
          touchThreshold: 20,
          lazyLoad: 'progressive',
        });
      }
    },

    /**
     * Match height
     */
    __doMatchHeight: () => {
      if(wntrTheme.body.find('.info-column__text').length > 0) {
        wntrTheme.body.find('.info-column__text').matchHeight();
      }

      if(wntrTheme.body.find('.info-column__picture').length > 0) {
        wntrTheme.body.find('.info-column__picture').matchHeight();
      }

      if(wntrTheme.body.find('.spot-grid__content-heading').length > 0 && $(window).width() >= 610) {
        wntrTheme.body.find('.spot-grid__content-heading').matchHeight();
      }

      if(wntrTheme.body.find('.spot-grid__content-text').length > 0 && $(window).width() >= 610) {
        wntrTheme.body.find('.spot-grid__content-text').matchHeight();
      }

      if(wntrTheme.body.find('.insurance-preview__mobile-card').length > 0) {
        wntrTheme.body.find('.insurance-preview__mobile-card').matchHeight();
      }

      if(wntrTheme.body.find('.menu__illustration').length > 0) {
        wntrTheme.body.find('.menu__illustration').matchHeight();
      }

      if(wntrTheme.body.find('.board-member__content').length > 0) {
        wntrTheme.body.find('.board-member__content').matchHeight();
      }

      if(wntrTheme.body.find('.search-result-title').length > 0) {
        wntrTheme.body.find('.search-result-title').matchHeight();
      }
    },

    /**
     * Toggle content tabs
     */
    __toggleContentTabs: () => {
      wntrTheme.body.find('.content-tabs__nav-button').on('click', function() {
        const el = $(this);

        el.closest('.content-tabs').find('.content-tabs__nav-button').removeClass('is-active');
        el.closest('.content-tabs').find('.content-tabs__content-inner').removeClass('is-active');

        el.addClass('is-active');
        wntrTheme.body
          .find('.content-tabs__content-inner[data-tab-content=' + el.data('tab') + ']')
          .addClass('is-active');
      });
    },

    /**
     * Toggle header background color on scroll
     */
    __toggleHeaderBackground: () => {
      let scrollTimeout = null;
      const throttle = 50;

      toggleHeaderBackgroundClass();

      // Simple scroll throttle
      $(window).on('scroll', function() {
        if(!scrollTimeout) {
          scrollTimeout = setTimeout(function() {
            toggleHeaderBackgroundClass();
            scrollTimeout = null;
          }, throttle);
        }
      });

      function toggleHeaderBackgroundClass() {
        const scroll_length = 5;
        const scroll = $(window).scrollTop();

        if(scroll >= scroll_length) {
          wntrTheme.body.find('header').addClass('header--solid');
        } else {
          wntrTheme.body.find('header').removeClass('header--solid');
        }
      }
    },

    /**
     * Toggle desktop sub menus
     */
    __toggleDesktopSubMenus: () => {
      const sub_menu_links = wntrTheme.body.find('.site-navigation-wrapper-desktop a');

      // Add a negative tabindex to all a-tags
      sub_menu_links.attr('tabindex', '-1');

      // Toggle menu with mouse enter on the parent links
      wntrTheme.body.find('.site-navigation-top-wrapper-desktop .btn--arrow-down').on('mouseenter', function() {
        if($(this).hasClass('menu-item--active')) {
          //closeMenu();
        } else {
          openMenu($(this));
        }
      });

      wntrTheme.body.find('.site-navigation-top-wrapper-desktop > ul > li > a').on('focus', function() {
        openMenu($(this));
      });

      // Close menu on main, close, footer and header click
      wntrTheme.body
        .find('.site-navigation-desktop__close-menu, .header__logo-wrapper, main, footer')
        .on('click', function() {
          closeMenu();
        });

      // Close menu on esc click
      $(document).keyup(function(e) {
        if(e.keyCode === 27) {
          closeMenu();
        }
      });

      wntrTheme.body.find('.site-navigation-wrapper-desktop__toggle-sub-menu').on('mouseenter', function() {
        $(this).closest('li').next().slideDown('fast');
        $(this).addClass('is-active');
      });

      wntrTheme.body.find('.site-navigation-wrapper-desktop__toggle-sub-menu').on('focus', function() {
        $(this).closest('li').next().slideDown('fast');
        $(this).addClass('is-active');
      });

      wntrTheme.body.find('.site-navigation-wrapper-desktop').on('mouseleave', function() {
        if($(this).hasClass('site-navigation-wrapper-desktop--active')) {
          closeMenu();
        }
      });

      wntrTheme.body.find('.header__nav-bar-my-pages').on('focusin', function() {
        closeMenu();
      });

      function closeMenu() {
        wntrTheme.body.find('.site-navigation-top-wrapper-desktop a').removeClass('menu-item--active');
        wntrTheme.body.find('.site-navigation-wrapper-desktop').removeClass('site-navigation-wrapper-desktop--active');
        sub_menu_links.attr('tabindex', '-1');
        wntrTheme.body.find('header').removeClass('desktop-menu-active');
      }

      function openMenu(el) {
        const sub_menu = wntrTheme.body.find(
          '.site-navigation-wrapper-desktop[data-menu-id=' + el.data('menu-to-toggle') + ']'
        );
        wntrTheme.body.find('header').addClass('desktop-menu-active');
        wntrTheme.body.find('.site-navigation-top-wrapper-desktop a').removeClass('menu-item--active');
        el.addClass('menu-item--active');

        wntrTheme.body.find('.site-navigation-wrapper-desktop').removeClass('site-navigation-wrapper-desktop--active');
        sub_menu.addClass('site-navigation-wrapper-desktop--active');

        sub_menu.find('a').removeAttr('tabindex');
        sub_menu.find('a').removeClass('last-menu-link');

        if(wntrTheme.body.find('.menu__illustration').length > 0) {
          wntrTheme.body.find('.menu__illustration').matchHeight();
        }
      }
    },

    /**
     * Toogle header search
     */
    __toggleHeaderSearch: () => {
      // Toggle header search with button
      const searchEl = wntrTheme.body.find('.header__nav-search-inner').children();
      searchEl.attr('tabindex', '-1');
      wntrTheme.body.find('.header__nav-bar-search-btn').on('click', function() {
        searchEl.attr('tabindex', '0');
        const el = $(this);
        wntrTheme.header.toggleClass('search-active');
        if(wntrTheme.header.hasClass('search-active')) {
          el.text(el.data('close'));
          wntrTheme.body.find('.header__nav-search input').focus();
          wntrTheme.body.find('.header__nav-bar-select-options a').attr('tabindex', '-1');
          wntrTheme.body.find('.header__nav-bar-select-btn').removeClass('options-active');
        } else {
          el.text(el.data('search'));
        }
      });

      // Close header search with esc
      $(document).keyup(function(e) {
        if(e.keyCode === 27 && wntrTheme.header.hasClass('search-active')) {
          wntrTheme.header.removeClass('search-active');
          wntrTheme.body
            .find('.header__nav-bar-search-btn')
            .text(wntrTheme.body.find('.header__nav-bar-search-btn').data('search'));
        }
      });
    },

    /**
     * Toogle header select options
     */
    __toggleHeaderSelectOptions: () => {
      const options = wntrTheme.body.find('.header__nav-bar-select-options a');
      const select_buttons = wntrTheme.body.find('.header__nav-bar-select-btn');

      // Add a negative tabindex to all a-tags
      options.attr('tabindex', '-1');

      // device detection
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        // Toggle header search with button
        wntrTheme.body.find('.header__nav-bar-select-btn').on('click', function() {
          const el = $(this);

          if(el.hasClass('options-active')) {
            select_buttons.removeClass('options-active');
            options.attr('tabindex', '-1');
          } else {
            select_buttons.removeClass('options-active');
            options.attr('tabindex', '-1');

            el.addClass('options-active');
            el.closest('.header__nav-bar-select').find('.header__nav-bar-select-options a').removeAttr('tabindex');
          }
        });
      } else {
        // Toggle header search with button
        wntrTheme.body.find('.header__nav-bar-select-btn').on('mouseenter', function() {
          const el = $(this);
          options.attr('tabindex', '-1');
          el.addClass('options-active');
          el.closest('.header__nav-bar-select').find('.header__nav-bar-select-options a').removeAttr('tabindex');
        });

        wntrTheme.body.find('.header__nav-bar-select-options').on('mouseleave', function() {
          select_buttons.removeClass('options-active');
          options.attr('tabindex', '-1');
        });
      }

      // Close menu on main, close, footer and header click
      wntrTheme.body
        .find('.site-navigation-desktop__sub-menu, .header__logo-wrapper, main, footer')
        .on('click', function() {
          select_buttons.removeClass('options-active');
          options.attr('tabindex', '-1');
        });
    },

    /**
     * Toogle mobile menu
     */
    __toggleMobileMenu: () => {
      const menu_links = wntrTheme.body.find('.site-navigation-wrapper a');

      // Add a negative tabindex to allow animations
      menu_links.attr('tabindex', '-1');

      // Toggle mobile menu with button click
      wntrTheme.body.find('.header__toggle-menu-btn').on('click', function() {
        const el = $(this);

        wntrTheme.header.toggleClass('mobile-menu-active');
        wntrTheme.body.toggleClass('mobile-menu--active');
        el.toggleClass('is-active');

        if(wntrTheme.header.hasClass('mobile-menu-active')) {
          menu_links.removeAttr('tabindex');
          wntrTheme.body.find('.header__nav-bar-select-options a').attr('tabindex', '-1');
          wntrTheme.body.find('.header__nav-bar-select-btn').removeClass('options-active');

          // Save current position from top
          wntrTheme.current_position = wntrTheme.document.scrollTop();
          // SetTimeout till the css animation has ended
          setTimeout(function() {
            wntrTheme.body.addClass('body--fixed');
          }, 200);
        } else {
          menu_links.attr('tabindex', '-1');
          wntrTheme.body.removeClass('body--fixed');
          wntrTheme.document.scrollTop(wntrTheme.current_position);
        }
      });

      // Toggle mobile submenu with click
      wntrTheme.body.find('.header__toggle-sub-menu').on('click', function() {
        const el = $(this);

        el.closest('li').toggleClass('current-page-ancestor');
      });
    },

    /**
     * Check if mouse is used
     */
    __checkIfMouseIsUsed: () => {
      // Let the document know when the mouse is being used
      document.body.addEventListener('mousedown', function() {
        document.body.classList.add('using-mouse');
      });
      // Re-enable focus styling when Tab is pressed
      document.body.addEventListener('keydown', function(event) {
        if(event.keyCode === 9) {
          document.body.classList.remove('using-mouse');
        }
      });
    },

    /**
     * Scroll to employee team
     */
    __scrollToEmployee: () => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const team = urlParams.get('team');

      if(team && team.length > 0 && wntrTheme.body.find('.page-section-employees').length > 0) {
        history.scrollRestoration = 'manual';
        const $team_el = $('#employee__team-' + team);

        setTimeout(function() {
          $('html, body').animate(
            {
              scrollTop: $team_el.offset().top - 20,
            },
            'slow',
            'swing',
            function() {
              $team_el
                .find('.employee__department-heading')
                .addClass('handorgel__header--open handorgel__header--opened');
              $team_el
                .find('.handorgel__content')
                .addClass('handorgel__content--open handorgel__content--opened')
                .css('height', 'auto');
            }
          );
        }, 200);
      }
    },
  };

  $(document).ready(wntrTheme.init);
})(jQuery);
